export function formatFileName(name: string) {
  return name.replaceAll(/[^\dA-Za-z]/g, "_").replaceAll(/_+/g, "_");
}
